<template>
	<div>
		<div class="actDiv">
			<a-button size="small"   icon="plus" @click="addFlag=true">新增</a-button>
		</div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"  
					   rowKey="id" :pagination="{hideOnSinglePage:true}" @expand="expandTable"  :expandedRowKeys="expandedRowKeys">
			<span slot="scanType"  slot-scope="text, record">
					{{record.prepay==0 ? '全部' : (record.prepay==1 ? '预付费' :'后付费')}}
			</span>
			<span slot="stateName"  slot-scope="text, record">
					{{record.state==1 ? '正在执行' : '未执行'}}
			</span>
			<span slot="modelName"  slot-scope="text, record">
					{{record.model==1 ? '自动' : '手动'}}
			</span>
			<span slot="theAction" slot-scope="text, record">
			      <a-button size="small" type="link" @click="editContent(record)">修改</a-button>
				  <a-button size="small"  type="link" @click="deleteContent(record)">删除</a-button>
				  <a-button size="small" v-if="record.state==1"  type="link" @click="closeContent(record)">关闭任务</a-button>
				  <a-button size="small" v-else  type="link" @click="openContent(record)">开启任务</a-button>
				  <a-button size="small"  type="link" @click="showScanRecord(record)">扫描记录</a-button>
				  <a-button size="small"  type="link" @click="showPArrearageCustomers(record)">欠费用户记录</a-button>
				  <a-button size="small"  type="link" @click="showPSmsLogs(record)">短信发送记录</a-button>
			</span>
			<a-table rowKey = "id"  size="small"  slot="expandedRowRender" slot-scope="text" :columns="innerColumns" :data-source="neighborList" :pagination="false">
				<span slot="theChildAction" slot-scope="text, record">
					  <a-button size="small"  type="link" @click="showCArrearageCustomers(record)">欠费用户记录</a-button>
					  <a-button size="small"  type="link" @click="showCSmsLogs(record)">短信发送记录</a-button>
				</span>
			</a-table>
		</a-table>
		<a-drawer title="新增扫描任务" :visible="addFlag"  width="500" @close="onAddClose" :destroyOnClose='true' :maskClosable="false">
			<AddScanningTask @cancelAdd="onAddClose" @refreshList="queryDataList"/>
		</a-drawer>
		<a-drawer title="修改扫描任务" :visible="editFlag"  width="500" @close="onEditClose" :destroyOnClose='true' :maskClosable="false">
			<EditScanningTask :theObj="theObj"  @cancelEdit="onEditClose" @refreshList="queryDataList"/>
		</a-drawer>
		<a-drawer title="扫描记录" :visible="recordFlag"  width="500" @close="recordFlag = false" :destroyOnClose='true'>
			<ShowScanTaskRecord :theObj="theObj"/>
		</a-drawer>
		<a-drawer title="欠费用户记录" :visible="customerFlag"  width="800" @close="customerFlag = false" :destroyOnClose='true'>
			<ShowScanArrearageCustomers :taskId="theObj.id" :neighborId="theNeighborId"/>
		</a-drawer>
		<a-drawer title="短信发送记录" :visible="smsFlag"  width="600" @close="smsFlag = false" :destroyOnClose='true' >
			<ShowScamSmsLogs :taskId="theObj.id" :neighborId="theNeighborId"/>
		</a-drawer>
	</div>
</template>

<script>
	const columns = [
		{
			title: '开始日期',
			dataIndex: 'begindate',
			width:100,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '结束日期',
			dataIndex: 'enddate',
			width:100,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '执行时间',
			dataIndex: 'time',
			width:100,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '阈值',
			dataIndex: 'threshold',
			width:100,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '扫描类型',
			dataIndex: 'prepay',
			width:120,
			scopedSlots: { customRender: 'scanType' },
			className:'v-cell',
			align:'center',
			
		},
		{
			title: '任务状态',
			dataIndex: 'state',
			width:100,
			scopedSlots: { customRender: 'stateName' },
			className:'v-cell',
			align:'center',
		},
		{
			title: '短信发送方式',
			dataIndex: 'model',
			width:150,
			scopedSlots: { customRender: 'modelName' },
			className:'v-cell',
			align:'center',
		},
		{
		    title: '操作',
		    key: 'pid',
		    scopedSlots: { customRender: 'theAction' },
			width:240,
			className:'v-cell',
			align:'center',
		  },
	];
	const  innerColumns=[
		{
			title: '小区名称',
			dataIndex: 'neighborname',
			width:150,
			className:'v-cell',
			align:'center',
		},
		{
		    title: '操作',
		    key: 'id',
		    scopedSlots: { customRender: 'theChildAction' },
			width:120,
			className:'v-cell',
			align:'center',
		  },
	];
	import AddScanningTask from '../components/AddScanningTask.vue'
	import EditScanningTask from '../components/EditScanningTask.vue'
	import ShowScanTaskRecord from '../components/ShowScanTaskRecord.vue'
	import ShowScanArrearageCustomers from '../components/ShowScanArrearageCustomers.vue'
	import ShowScamSmsLogs from '../components/ShowScanSmsLogs.vue'
	export default{
		components:{
			AddScanningTask,
			EditScanningTask,
			ShowScanTaskRecord,
			ShowScanArrearageCustomers,
			ShowScamSmsLogs,
		},
		data(){
			return{
				columns,
				innerColumns,
				loading:true,
				addFlag:false,
				editFlag:false,
				recordFlag:false,
				customerFlag:false,
				smsFlag:false,
				list:[],
				neighborList:[],
				expandedRowKeys:[],
				theObj:{},
				themodal:null,
				theNeighborId:null,
			}
		},
		methods:{
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.SCANNING_TASK_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			expandTable:function(expanded, record){
				this.expandedRowKeys.pop();
				if(expanded){
					this.expandedRowKeys.push(record.id);
					this.theObj = record;
					this.queryNeighbors(record);
				}
			},
			queryNeighbors:function(item){
				let url = this.Api.getLastUrl(this.Api.SCANNING_TASK_NEIGHBORS_URL);
				let param = {theId:item.id};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});	
			},
			editContent:function(item){
				if(item.state == 1){
					this.$message.error('请先关闭任务');
				}else{
					this.theObj = this.Config.deepClone(item);
					this.editFlag = true;
				}
			},
			deleteContent:function(item){
				if(item.state == 1){
					this.$message.error('请先关闭任务');
				}else{
					this.themodal = this.$confirm({
						title:'确定删除该条记录?',
						content:'',
						okType: 'warning',
						centered:true,
						onOk: h=>{
							this.theObj = item;
							this.realDelete();
						},
					});
				}
			},
			realDelete:function(){
				let url = this.Api.getLastUrl(this.Api.SCANNING_TASK_DELETE_URL);
				let param = {
					theId:this.theObj.id,
				}
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.themodal.destroy();
						this.queryDataList();
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			closeContent:function(item){
				this.themodal = this.$confirm({
					title:'确定关闭当前任务?',
					content:'',
					okType: 'warning',
					centered:true,
					onOk: h=>{
						this.theObj = item;
						this.changeScanningTask(true);
					},
				});
			},
			openContent:function(item){
				this.themodal = this.$confirm({
					title:'确定开启当前任务?',
					content:'',
					okType: 'warning',
					centered:'true',
					onOk: h=>{
						this.theObj = item;
						this.changeScanningTask(false);
					},
				});
			},
			changeScanningTask:function(closeFlag){
				let url = this.Api.getLastUrl(this.Api.SCANNING_TASK_CHANGE_URL);
				let param = {
					theId:this.theObj.id,
					changeType:closeFlag ? 'close' : 'open'
				}
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					this.$message.success(msg);
					if(code == this.Api.HTTP_OK_CODE){
						this.themodal.destroy();
						this.queryDataList();
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			onAddClose:function(){
				this.addFlag = false;
			},
			onEditClose:function(){
				this.editFlag = false;
			},
			showScanRecord:function(item){
				this.theObj = item;
				this.recordFlag = true;
			},
			showPArrearageCustomers:function(item){
				this.theObj = item;
				this.theNeighborId = null;
				this.customerFlag = true;
			},
			showCArrearageCustomers:function(item){
				this.theNeighborId = item.neighborid;
				this.customerFlag = true;
			},
			showPSmsLogs:function(item){
				this.theObj = item;
				this.theNeighborId = null;
				this.smsFlag = true;
			},
			showCSmsLogs:function(item){
				this.theNeighborId = item.neighborid;
				this.smsFlag = true;
			}
		},
		created() {
			this.queryDataList();
		}
	}
</script>

<style>
</style>
